/**
 * List Schema of TipoRelatorio
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {TipoRelatorio} from '@/model/resource/TipoRelatorio'

/* TODO: review generated schema */
export class ListTipoRelatorioSchema extends Schema {
  readonly name = 'ListTipoRelatorio'

  readonly fieldSet: FieldSet<TipoRelatorio> = {
    idTipoRelatorioPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    formatoArquivoRelatorio: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.formatoArquivoRelatorio?.$id,
      },
    }),
    descricao: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
